const getAsesmenKelompokFunction = (
  data,
  selectedUnitKerja,
  selectedAssessedBy
) => {
  const unitKerja = data.unitKerja.find(
    (unitKerja) => Number(unitKerja.id_unit_kerja) === Number(selectedUnitKerja)
  );

  const asesmenKelompok = data.asesmenKelompok.find(
    (asesmenKelompok) =>
      asesmenKelompok?.unit_kerja === unitKerja?.nama_unit_kerja &&
      asesmenKelompok?.assessed_by === selectedAssessedBy
  );

  return asesmenKelompok;
};

export default getAsesmenKelompokFunction;
